<!-- <mat-progress-bar  style="position: fixed; top: 50vh; left: 10vw; width: 80vw" *ngIf="globals.projectCode && !globals.project && !globals.adminPage" mode="buffer"></mat-progress-bar> -->
<router-outlet></router-outlet>
